import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ROUTES } from "../../constants/routes";
import { useAuth } from "../../hooks/useAuth";
import { routeConfig, RouteConfig } from "../../utils/routeConfig";
import { AuthMiddleware } from "./AuthMiddleware";
import LoadingSpinner from "./LoadingSpinner";
import { ReactNode, useEffect } from "react";
import { RouteChangeListener } from "../../contexts/ThemeContext";
import { prefetchAppData } from "../../utils/dataPrefetch";
import { OnboardingOverlay } from "../features/Onboarding";

const AppRoutes = () => {
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isAuthenticated && !isLoading) {
      prefetchAppData();
    }
  }, [isAuthenticated, isLoading]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  const renderRoutes = (routes: RouteConfig[]) => {
    return routes.map((route: RouteConfig) => {
      const RouteComponent = route.component;
      const Layout = route.layout || (({ children }: { children: ReactNode }) => <>{children}</>);

      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <AuthMiddleware requireAuth={route.protected}>
              <Layout hideAppbar={route.hideAppbar}>
                <RouteComponent />
              </Layout>
            </AuthMiddleware>
          }
        >
          {route.children && renderRoutes(route.children)}
        </Route>
      );
    });
  };

  return (
    <BrowserRouter>
      <RouteChangeListener />
      <Routes>
        {renderRoutes(routeConfig)}
        <Route
          path="*"
          element={
            isAuthenticated ? (
              // Hide dashboard
              // <Navigate to={ROUTES.DASHBOARD} />
              <Navigate to={ROUTES.ASSETS} />
            ) : (
              <Navigate to={ROUTES.HOME} />
            )
          }
        />
      </Routes>
      <OnboardingOverlay />
    </BrowserRouter>
  );
};

export default AppRoutes;
